"use strict";

$.widget("fotobook.plainTextFontSizeBaseWidget", $.fotobook.fontSizeBaseWidget, {
    _create: function(){
        this._super();
        this.caption = this.options.editorWidget.caption;
    },
    _getTextContent: function(){
        return this.options.editorWidget._getTextContent();
    },
    _getCaption: function(){
        return this._getTextContent().closest(".caption");
    },
    _getValueFromProject: function(){
        var data_font_size = this._getTextContent().attr("data-font-size") || this._getCaption().attr("data-font-size");
        return this._fsPx2Num(data_font_size);
    },

    _setPreviewStyle: function(fontSize){
        var fsPx = this._fsNum2Px(fontSize),
            em = fontSize / this.options.def_size;

        this._getTextContent().css("font-size", em + "em").attr("data-font-size", fsPx);
        this._focusTextContent();
    },
    _removePreviewStyle: function(fontSize){
        this._setPreviewStyle(fontSize);
    },

    _focusTextContent: function(){
        var widget = this;
        if (document.activeElement !== this.input[0]){
            setTimeout(function(){
                widget._getTextContent().focus();
            }, 0);
        }
    },

    _changeFontSize: function(fontSize){
        this._getTextContent().trigger("keyup");
    },
});

$.widget("fotobook.plainTextFontSizeWidget", $.fotobook.plainTextFontSizeBaseWidget, {
});

$.widget("fotobook.spineFontSizeWidget", $.fotobook.plainTextFontSizeBaseWidget, {
    _setPreviewStyle: function(fontSize){
        this._super(fontSize);
        this.options.editorWidget._copySpine();
    },
});

